import React from "react";

const Blog6 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>
        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        <p className="paragraph-content">
          We all go through a moment in our lives where we believe we are better
          than everyone else. So, when you think you’re the brightest person in
          the room, you’re in the wrong room. Many startups fail because they
          believe they are the most inventive and consumer-centric startups, but
          they fail to grasp the needs of the consumers.
        </p>

        <p className="paragraph-heading">
          So how did I saw the potential for a product and how did I go for it?
        </p>

        <p className="paragraph-content">
          Just keep 3 pointers in your mind whenever you think you have an idea
          and you want to implement it.
        </p>

        <p
          className="paragraph-content"
          style={{ color: "black", fontWeight: 500 }}
        >
          1. Think as a Consumer and have a sample ‘n’ size interview with them
          about your product.
        </p>

        <p className="paragraph-content">
          This is the most straightforward and user-friendly method of
          determining whether or not your product will be generally accepted in
          the market. If you receive a negative response from your sample
          interview, keep in mind that you will need to make some changes to
          your product in order for it to be a good fit for the market. People
          always give up when they receive negative feedback; they don’t put up
          their best effort to address the problem; instead, they abandon it.
          and launch a new business. Business is all about patience and ethical
          practices; if you can achieve this, believe me, you and your practices
          will be recognized sooner or later; it’s all about time.
        </p>

        <p
          className="paragraph-content"
          style={{ color: "black", fontWeight: 500 }}
        >
          2. Market research and Product categorization.
        </p>

        <p className="paragraph-content">
          Market research and product categorization are the heart of your
          project; if you lack in these areas, your entire product plan will
          fail. As engineers, we have learned a few things such as first
          assessing a problem and then providing a solution, which is why you
          must first conduct market research on your specific products. Google
          is always useful when looking for information or statistics. The more
          research you have at your disposal, the better view you will have of
          your product. Categorization is the process of selecting a certain
          domain for your goods, such as FinTech, FMCG, Chemicals, and so on.
          All of them should be classified according to their sub-Domain. These
          things will simplify your life and you would have peace of mind
          (Sarcasm Intended).
        </p>

        <p
          className="paragraph-content"
          style={{ color: "black", fontWeight: 500 }}
        >
          3. Documentation, Finances, and Risk
        </p>

        <p className="paragraph-content">
          these 3 are like brothers and all are dependent on each other if you
          miss anyone then you're in for a very long day
        </p>

        <p className="paragraph-content">
          Documentation is always linked to your personality; the more organized
          your documents are, the more particular you are about things; if your
          Documenting skills are scruffy, you are a laid-back type of person;
          yes, there are exceptions for some people; however, you must take time
          out of your busy schedule to organize the documents because you never
          know when all of these things will be needed emphasis on
          Digitalisation of Documents on Drive or any Digital Storage.
        </p>

        <p className="paragraph-content">
          Finances are often tough when you come from a non-financial
          background, but don’t give up hope; the local grocery store guy
          doesn’t need a fancy degree to understand finance, so it’s actually
          rather simple. Startups are notoriously sloppy with finances but over
          time, they learn from their failures and apply what they’ve learned to
          future endeavors. So just because you don’t know finance doesn’t mean
          you can’t start a startup or a small business. The beauty of learning
          is that it’s fun, but it’s also scary because there’s money at stake.
        </p>

        <p className="paragraph-content">
          Why do people say High-risk High-reward, but when you’re starting out,
          you have to take calculated risk in order to withstand the danger if
          it ever arises, and you must have a backup plan in case the risk
          outruns you and you fall? Because no one is flawless, calculated risk
          should be considered throughout your initial phase during your Trial
          and Error Period. However, be sure you have that level of risk
          appetite. Risk Mitigation is the most difficult duty for an
          entrepreneur or startup since it is one of the most challenging jobs,
          but it is learning, and I live by the phrase “A person learns till he
          dies.”
        </p>

        <p className="paragraph-content">
          I’m not a professional writer, but I write what comes to me in order
          to communicate my message; I realize this isn’t a proper title
          description, but these are some of the ways I was able to Design and
          Develop Products for Our Startup.
        </p>

        <p className="paragraph-content">
          P.S. I’m new to writing, but if you give me a chance, I’ll attempt to
          write even better and more succinctly.
        </p>

        <p className="paragraph-content">Thank you and have a nice day.</p>
      </div>
    </div>
  );
};

export default Blog6;
